import DatabaseReturnClientRepository from "@domain/repositories/DatabaseReturnClientRepository";
import { UserStore } from "@domain/stores/UserStore";
import UseCase from "@domain/UseCase";
import { userRoles } from "@domain/models/User";
import { Timestamp } from "firebase/firestore";

type Input = {
  startDate: Timestamp;
  endDate: Timestamp;
};

type Output = void;

export class WatchCardsReturnClientsUseCase implements UseCase<Input, Output> {
  constructor(
    private readonly userStore: UserStore,
    private readonly databaseReturnClientRepository: DatabaseReturnClientRepository
  ) {}

  execute({ startDate, endDate }: Input) {
    const user = this.userStore.user;

    if (user.role === userRoles.root || user.role === userRoles.admin) {
      return this.databaseReturnClientRepository.watchReturnClientsByDateAdmin(startDate, endDate);
    }

    if (user.role === userRoles.manager) {
      return this.databaseReturnClientRepository.watchReturnClientsByDateManager(
        startDate,
        endDate,
        user.operatorsIds
      );
    }

    return;
  }
}
